/* eslint-disable object-shorthand */

export var PACKAGE_BUILD_DATE = '2026-10-20T19:18:04.603Z';
export var PACKAGE_NAME = 'invision-customercare';
export var PACKAGE_VERSION = '26.3.10600-2663888';
export default {
  PACKAGE_BUILD_DATE: PACKAGE_BUILD_DATE,
  PACKAGE_NAME: PACKAGE_NAME,
  PACKAGE_VERSION: PACKAGE_VERSION
};